import CallIcon from '@mui/icons-material/Call';
import ChatIcon from '@mui/icons-material/Chat';
import LanguageIcon from '@mui/icons-material/Language';
import MailIcon from '@mui/icons-material/Mail';
import VoicemailIcon from '@mui/icons-material/Voicemail';
import * as React from 'react';
import { ChannelItemType } from '../../../sic-lib/enums/ChannelItemType';

interface Props {
    channelItemType: ChannelItemType;
}

export default function ChannelItemIcon({ channelItemType }: Props) {
    const channelIcon = React.useMemo(() => {
        switch (channelItemType) {
            case ChannelItemType.call:
                return <CallIcon />;
            case ChannelItemType.email:
                return <MailIcon />;
            case ChannelItemType.message:
                return <ChatIcon />;
            case ChannelItemType.voicemail:
                return <VoicemailIcon />;
            default:
                return <LanguageIcon />;
        }
    }, [channelItemType]);

    return channelIcon;
}
